module.exports = __webpack_public_path__ + "static/media/pleated.a2ae08c7.svg";